<template>
  <symbols/>
  <router-view/>
</template>

<script>
/* eslint-disable */

import symbols from '@/components/IconSymbol.vue'

export default {
  name: 'App',
  components: {
    symbols
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50;
  margin-top: 60px; */
}
</style>
